import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {MembershipDropdownOwnProps, MembershipDropdownRuntimeProps} from './interfaces'
import {MembershipDropdown as Presentation} from './membership-dropdown'

const mapRuntime = ({actions: {editStep}}: DetailsPageAppProps): MembershipDropdownRuntimeProps => ({editStep})

export const MembershipDropdown = connect<MembershipDropdownOwnProps, MembershipDropdownRuntimeProps>(mapRuntime)(
  Presentation,
)
export * from './interfaces'
